export default {

    // ADMIN DASHBOARD
    GET_OVERALL_METRICS: {
        url: "/api/v1/admin-dashboard/overall/{timeline}",
        method: "get",
    },
    GET_PORTFOLIO_METRICS_DIGIREP: {
        url: "/api/v1/admin-dashboard/portfolio/digirep",
        method: "get",
    },
    GET_PORTFOLIO_METRICS_LEADS: {
        url: "/api/v1/admin-dashboard/portfolio/leads/{timeline}",
        method: "get",
    },
    GET_PORTFOLIO_METRICS_PAYMENT: {
        url: "/api/v1/admin-dashboard/portfolio/payment/{timeline}",
        method: "get",
    },
    GET_PRODUCT_METRICS: {
        url: "/api/v1/admin-dashboard/product/{timeline}",
        method: "get",
    },
    GET_STATE_METRICS: {
        url: "/api/v1/admin-dashboard/state/{timeline}",
        method: "get",
    },
}